import React from 'react';
import { CheckCircle, Plus, Shield, Star } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

export const Pricing = () => {
  const handleCTAClick = () => {
    window.open('https://sistema.benmais.com/auto-contratacao?ref=MWZkYjg4ZDEtYzdiOC00ZTZiLWEzZDAtMGE5YjlkMjQ5ZTBhOmJiOGZmOTBiLWM5NjYtNDVmZi05MzAwLTUwNTkwMzhjYTczMQ==', '_blank');
  };

  const features = [
    'Telemedicina 24 horas para titular + 4 dependentes',
    'Indenização de até R$ 10.000 por invalidez',
    'Indenização de R$ 10.000 por morte acidental',
    'Descontos de 10% a 70% em farmácias',
    'Auxílio funeral até R$ 3.000',
    'Descontos em consultas e exames médicos',
    'Assistência residencial emergencial',
    'Assistência jurídica completa'
  ];

  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-cyan-50 via-white to-blue-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16 space-y-4">
          <div className="inline-flex items-center gap-2 bg-[#00E5CC]/10 text-[#0A1E2E] px-4 py-2 rounded-full text-sm font-bold border-2 border-[#00E5CC]/20">
            <Star className="w-4 h-4 fill-[#00E5CC] text-[#00E5CC]" />
            Melhor Custo-Benefício
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
            Proteção Completa por um Preço Justo
          </h2>
          <p className="text-xl text-gray-600">
            Invista na segurança da sua família com o plano mais completo do mercado
          </p>
        </div>

        <Card className="border-4 border-[#00E5CC] shadow-2xl">
          <CardContent className="p-12">
            <div className="text-center mb-8 space-y-2">
              <div className="inline-flex items-center gap-2 bg-[#00E5CC] text-white px-4 py-2 rounded-lg text-sm font-bold mb-4">
                <Plus className="w-4 h-4" strokeWidth={3} />
                PLANO BEN+ALLCRED
              </div>
              <div className="flex items-baseline justify-center gap-2">
                <span className="text-2xl text-gray-600">R$</span>
                <span className="text-7xl font-bold text-[#00E5CC]">59,90</span>
                <span className="text-2xl text-gray-600">/mês</span>
              </div>
              <p className="text-gray-600 font-medium">
                Apenas R$ 1,99 por dia para proteger toda sua família
              </p>
            </div>

            <div className="bg-[#00E5CC]/10 rounded-xl p-6 mb-8 border border-[#00E5CC]/30">
              <p className="text-center text-[#0A1E2E] font-bold">
                ✓ Ativação imediata após o 1º pagamento
              </p>
            </div>

            <div className="space-y-4 mb-10">
              <h3 className="text-xl font-bold text-gray-900 mb-6">
                O que está incluído:
              </h3>
              {features.map((feature, index) => (
                <div key={index} className="flex items-start gap-3">
                  <Plus className="w-6 h-6 text-[#00E5CC] flex-shrink-0 mt-0.5" strokeWidth={3} />
                  <span className="text-gray-700 font-medium">{feature}</span>
                </div>
              ))}
            </div>

            <Button
              onClick={handleCTAClick}
              size="lg"
              className="w-full bg-[#00E5CC] hover:bg-[#00D4BE] text-[#0A1E2E] text-xl py-8 font-bold transition-all duration-300 hover:shadow-xl hover:scale-105"
            >
              <Plus className="w-6 h-6 mr-3" strokeWidth={3} />
              Quero os Benefícios
            </Button>

            <div className="mt-8 grid grid-cols-3 gap-6 pt-8 border-t border-gray-200">
              <div className="text-center">
                <div className="text-3xl font-bold text-[#00E5CC] mb-1">8</div>
                <div className="text-sm text-gray-600">Benefícios</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-[#00E5CC] mb-1">5</div>
                <div className="text-sm text-gray-600">Pessoas Cobertas</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-[#00E5CC] mb-1">24h</div>
                <div className="text-sm text-gray-600">Telemedicina</div>
              </div>
            </div>
          </CardContent>
        </Card>

        <p className="text-center text-gray-500 mt-8 text-sm">
          Cancele quando quiser, sem taxas ou multas
        </p>
      </div>
    </section>
  );
};
